import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, IconColor } from '../../../Icon';
import AlertIcon from '../../../../public/static/images/item/red-alert.svg';
import { AlertContainer, AlertText, AlertTitle } from './styled';

export const AlertMessage = () => {
  const { t } = useTranslation();

  return (
    <AlertContainer data-cy="alert-message">
      <Icon
        indent={false}
        height={30}
        width={30}
        color={IconColor.pink}
        IconComponent={AlertIcon}
      />
      <AlertText tag="body_2" data-cy="alert-message__content">
        <AlertTitle tag="body_2">
          {t('pages.current_item.attention')}
          {'! '}
        </AlertTitle>
        {t('pages.current_item.alert_message')}
      </AlertText>
    </AlertContainer>
  );
};
